// This route is a redirect stub. The actual Stripe Embedded Checkout now lives on
// the marketing lander at https://unbreakableapp.com/checkout. This redirect exists
// to catch any stale links, bookmarks, or promo page back-navigation. Phase 4 of
// the checkout move — see /Users/zackbart/Dev/bepresent/unbreakable/.motif/context.md
// (or the motif workflow history) for context.
import { useEffect } from 'react'
import { createFileRoute } from '@tanstack/react-router'

export const Route = createFileRoute('/register')({
  validateSearch: (search: Record<string, unknown>): { canceled?: boolean; error?: string } => ({
    canceled: search.canceled === 'true' ? true : undefined,
    error: (search.error as string) || undefined,
  }),
  head: () => ({
    meta: [{ title: 'Redirecting… | Unbreakable' }],
  }),
  component: RegisterRedirect,
})

function RegisterRedirect() {
  useEffect(() => {
    const search = typeof window !== 'undefined' ? window.location.search : ''
    window.location.replace(`https://unbreakableapp.com/checkout${search}`)
  }, [])

  return (
    <div className="min-h-screen flex items-center justify-center">
      <p className="text-gray-600">Redirecting to checkout…</p>
    </div>
  )
}
